module.exports = __webpack_public_path__ + "img/closeWhite24.a51de2c3.svg";